import React from 'react';

export const OrganizationSchema: React.FC = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Lot 20 Coffee Farmers Services",
    "alternateName": "Lot 20 Coffee",
    "url": "https://www.lot20.coffee",
    "logo": "https://www.lot20.coffee/favicon.svg",
    "description": "Producer-owned Kenyan specialty coffee company. We grow, process, and export experimental coffees directly from our own factories in Kenya's western highlands.",
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "Western Highlands",
      "addressCountry": "KE"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "sidney@lot20.coffee",
      "contactType": "sales"
    },
    "sameAs": [],
    "knowsAbout": [
      "Kenyan specialty coffee",
      "Anaerobic coffee processing",
      "Coffee fermentation",
      "Direct trade coffee",
      "Experimental coffee processing",
      "Coffee roasting samples"
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

interface CoffeeProductSchemaProps {
  name: string;
  description: string;
  imageUrl?: string;
  price?: number;
  availability?: string;
  slug: string;
}

export const CoffeeProductSchema: React.FC<CoffeeProductSchemaProps> = ({
  name,
  description,
  imageUrl,
  price,
  availability,
  slug,
}) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": name,
    "description": description,
    "image": imageUrl,
    "url": `https://www.lot20.coffee/coffee/${slug}`,
    "brand": {
      "@type": "Brand",
      "name": "Lot 20 Coffee"
    },
    "manufacturer": {
      "@type": "Organization",
      "name": "Lot 20 Coffee Farmers Services"
    },
    "category": "Specialty Coffee",
    "countryOfOrigin": "KE",
    ...(price && {
      "offers": {
        "@type": "Offer",
        "price": price,
        "priceCurrency": "USD",
        "availability": availability === 'AVAILABLE'
          ? "https://schema.org/InStock"
          : availability === 'PREORDER'
            ? "https://schema.org/PreOrder"
            : "https://schema.org/OutOfStock"
      }
    })
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};
